import React from "react";
import { Image } from "antd";
import { Eye, X } from "lucide-react";
import { MAX_IMAGES, MAX_SIZE_MB } from "../hooks/useImageAttachments";
import type { Attachment } from "../types";

interface AttachmentStripProps {
    attachments: Attachment[];
    onRemove: (id: string) => void;
}

const AttachmentStrip: React.FC<AttachmentStripProps> = ({ attachments, onRemove }) => {
    if (attachments.length === 0) return null;
    const atMax = attachments.length >= MAX_IMAGES;

    return (
        <div className="chat-v2-attach-strip">
            <div className="chat-v2-attach-thumbs">
                <Image.PreviewGroup>
                    {attachments.map(a => (
                        <div key={a.id} className={`chat-v2-attach-thumb chat-v2-attach-${a.status}`}>
                            <Image src={a.previewUrl} alt={a.fileName} preview={{ mask: <Eye size="1em" /> }} />
                            {a.status === "uploading" && <span className="chat-v2-attach-spinner" />}
                            <button type="button" className="chat-v2-attach-remove"
                                    onClick={(e) => { e.stopPropagation(); onRemove(a.id); }}
                                    aria-label="Remove image"><X size="1em" /></button>
                        </div>
                    ))}
                </Image.PreviewGroup>
            </div>
            {/* Proactive constraint messaging: format/size rule and the image-count cap, surfaced
                before the user hits either limit rather than only via the attach button's tooltip
                once they're already there. One caption row, not a separate block of text. */}
            <div className="chat-v2-attach-caption">
                <span className="chat-v2-attach-hint">PNG, JPEG, WEBP · up to {MAX_SIZE_MB}MB each</span>
                <span className={`chat-v2-attach-count${atMax ? " chat-v2-attach-count-max" : ""}`}>
                    {attachments.length}/{MAX_IMAGES}
                </span>
            </div>
        </div>
    );
};

export default AttachmentStrip;
